import { render, staticRenderFns } from "./FeedEventCard.vue?vue&type=template&id=5422cb5e&scoped=true"
import script from "./FeedEventCard.vue?vue&type=script&lang=js"
export * from "./FeedEventCard.vue?vue&type=script&lang=js"
import style0 from "./FeedEventCard.vue?vue&type=style&index=0&id=5422cb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422cb5e",
  null
  
)

export default component.exports